import { memo } from 'react';

import { IKnmPreview } from 'APIPackage/KnmSearchModule/interfaces/IKnmPreview';

import styles from './KnmPreview.module.scss';
import { KnmSubtitle } from './KnmSubtitle';
import { parseErknmValue } from '../common/parseErknmValue';

interface IPmControlProps {
  passportData: IKnmPreview;
}

export const PmControl = memo(({ passportData }: IPmControlProps) => {
  const supervisionType =
    passportData.pmErknm.supervisionType && parseErknmValue(passportData.pmErknm.supervisionType.value);

  const supervisionTypeLabel = () => {
    if (!supervisionType) {
      return '';
    }

    if (passportData.transferred && passportData.transferringAuthorities) {
      const ervkTransferringTitles = passportData.transferringAuthorities
        .filter(x => x.title !== undefined && x.title !== null)
        .map(x => x.title);
      const ervkTransferringShortTitles = passportData.transferringAuthorities
        .filter(x => x.shortTitle !== undefined && x.shortTitle !== null)
        .map(x => x.shortTitle);

      if (ervkTransferringShortTitles.length) {
        return `${supervisionType.number} - ${supervisionType.title} - передано от ${ervkTransferringShortTitles.join(
          ', ',
        )}`;
      }
      if (ervkTransferringTitles.length) {
        return `${supervisionType.number} - ${supervisionType.title} - передано от ${ervkTransferringTitles.join(
          ', ',
        )}`;
      }
    }

    return `${supervisionType.number} - ${supervisionType.title}`;
  };

  return (
    <div className={styles.ColumnContent}>
      <KnmSubtitle title="Контрольный (надзорный) орган">
        {passportData.pmErknm.knoOrganization && (
          <div className={styles.Row}>
            <div className={styles.ColText}>Наименование органа контроля</div>
            <div className={styles.ColValue}>
              {parseErknmValue(passportData.pmErknm.knoOrganization.value)?.fullName}
            </div>
          </div>
        )}
        {supervisionType && (
          <div className={styles.Row}>
            <div className={styles.ColText}>Вид контроля (надзора) и его номер</div>
            <div className={styles.ColValue}>{`${supervisionTypeLabel()}`}</div>
          </div>
        )}
      </KnmSubtitle>
    </div>
  );
});
